<template>
    <div class="modal fade game-point-note-modal" id="qrShareModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="border: none;">
                <div class="modal-body">
                    <section class="sub-header-wrapper">
                        <div class="qrPreview-image">
                            <img data-bs-dismiss="modal" @click="closeOffer" class="gp-closeButton"
                                src="@/assets/images/closeButton.svg" alt="closebutton">
                            <div class="footer-social-bx">
                                <div class="f-social-icon">
                                    <a :href="`https://telegram.me/share/url?url=${qrCode}`" target="_blank"><img
                                            src="@/assets/images/telegram-icon.svg" alt="telegram" /></a>
                                </div>
                                <div class="f-social-icon">
                                    <a :href="`https://wa.me/?text=${qrCode}`" target="_blank"><img
                                            src="@/assets/images/whatsapp-icon.svg" alt="whatsapp" /></a>
                                </div>
                                <div class="f-social-icon">
                                    <a :href="`https://www.instagram.com/create/story?media=${qrCode}`" target="_blank"><img
                                            src="@/assets/images/instageam-icon.svg" alt="instagram-icon" /></a>
                                </div>

                                <div class="f-social-icon">
                                    <a :href="`https://www.facebook.com/sharer/sharer.php?u=${qrCode}`" target="_blank">
                                        <img loading="lazy" src="@/assets/images/facebook-icon.svg" alt="facebook-icon" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QRCODESHARE',
    props: ['qrCode']
}
</script>

<style>

</style>